import React from "react";
import "./AccordionFilter.scss";
import "../Filter.scss";
import { Collapse, Checkbox } from 'antd';
import { CaretUpOutlined } from '@ant-design/icons';

const { Panel } = Collapse;

const AccordionFilter = ({ specialKey, title, items, temporaryFilterList, addToList, removeFromList }) => {
  return (
    <div className="Filter AccordionFilter">
      <Collapse
        bordered={false}
        defaultActiveKey={['1']}
        expandIconPosition="end"
        expandIcon={({ isActive }) => <CaretUpOutlined rotate={isActive ? 180 : 0} />}
      >
        <Panel className="title" header={title} key="1">
          {
            items.map((item, index) => {
              return (
                <div className="item" key={index}>
                  {
                    Array.isArray(item)
                      ?
                      <>
                        <div>{item[0]}</div>
                        <Checkbox defaultChecked={temporaryFilterList[specialKey] && temporaryFilterList[specialKey].includes(item[1])} onChange={(e) => e.target.checked ? addToList(specialKey, item[1]) : removeFromList(specialKey, item[1])} />
                      </>
                      :
                      <>
                        <div>{item}</div>
                        <Checkbox defaultChecked={temporaryFilterList[specialKey] && temporaryFilterList[specialKey].includes(item)} onChange={(e) => e.target.checked ? addToList(specialKey, item) : removeFromList(specialKey, item)} />
                      </>
                  }
                </div>
              )
            })
          }
        </Panel>
      </Collapse>
    </div>
  )
};

export default AccordionFilter;
